import { easeInOutQuad } from '~/utils/easeInOutQuad'

/**
 * Скроллит страницу к указанному значению
 * @param {number} to
 * @param options options.duration
 * @param {number} options.offset
 * @param {number} options.duration
 */
export const scrollToPosition = (to = 0, {
  horizontal = false,
  offset = 0,
  duration = 600,
  element = document.documentElement,
} = {}) => {
  const scrollKey: keyof Pick<HTMLElement, 'scrollLeft' | 'scrollTop'> = horizontal ? 'scrollLeft' : 'scrollTop'
  const toWithOffset = to + offset
  const start = element[scrollKey]
  const change = toWithOffset - start
  const startDate = new Date().getTime()

  animateScroll()

  function animateScroll() {
    const currentDate = new Date().getTime()
    const currentTime = currentDate - startDate

    element[scrollKey] = easeInOutQuad(currentTime, start, change, duration)

    if (currentTime < duration) {
      requestAnimationFrame(animateScroll)
    } else {
      element[scrollKey] = toWithOffset
    }
  }
}
